import { render, staticRenderFns } from "./Subdistrict.vue?vue&type=template&id=4807a411"
import script from "./Subdistrict.vue?vue&type=script&lang=js"
export * from "./Subdistrict.vue?vue&type=script&lang=js"
import style0 from "./Subdistrict.vue?vue&type=style&index=0&id=4807a411&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports